import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
const SiteContext = React.createContext(undefined);
export function SiteProvider({ config, children, }) {
    return _jsx(SiteContext.Provider, { value: config, children: children });
}
export function useSiteManifest() {
    const config = useContext(SiteContext);
    return config;
}
